import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { toolsDetailsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsStack = createStackNavigator();

const ToolsDetailsNavigator = () => {
  return (
    <ToolsDetailsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {toolsDetailsConfig.map(({ Component, name }) => (
        <ToolsDetailsStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsStack.Navigator>
  );
};

export { ToolsDetailsNavigator };
